import styled from 'styled-components';

import { colors } from 'config/theme';

export const SidebarWrapper = styled.div<{ expanded: boolean }>`
  padding: 1em;
  padding-left: ${(props) => !props.expanded && '0.5em'};
  padding-right: ${(props) => !props.expanded && '0.5em'};
  border-right: 2px solid ${colors.lightGray};
  min-width: ${(props) => (props.expanded ? '300px' : 'max-content')};
  max-width: ${(props) => (props.expanded ? '300px' : 'max-content')};
  // view height - (banner + header)
  max-height: calc(100vh - (36px + 66px));
  overflow-y: auto;

  header {
    align-items: center;
    color: #263238;
    display: flex;
    justify-content: space-between;
  }

  hr {
    padding-top: 1em;
  }

  section {
    padding-top: 1em;

    .MuiFormControl-root {
      margin-top: 1em;
    }
  }

  .flagged-select > div {
    padding-left: 6px;
  }

  .date-reviewed > div {
    padding-right: 1.5px;
  }
`;
